import Bloc from './Bloc.js';
import Types from './Types.js';

export default class BreakEntity extends Bloc {

	constructor (src, ctx) {

		super("breakentity", src, ctx);
		this.f = (src, ins) => {
			let entity = ins[0];
			if (ins[0] && ins[0].type && ins[0].no !== undefined)
				entity = src.master.find(ins[0]);
			if (!entity)
				return [null, null, null, null, null]
			return [entity.hp, entity.maxhp];
		}
		this.types = [Types.entity];
	}
}